export default "__VITE_ASSET__D0GTRJyK__"